import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { FreeFieldPermissionProfileSidePanel } from "components/SidePanel/FreeFieldPermissionProfile/FreeFieldPermissionProfileSidePanel";

export const RemovableFreeFieldProfile = (props: RemovableProps<server.dto.FreeFieldProfileSmall>) => {

  return <RemovableLabel
    {...props}
  >
    <FreeFieldPermissionProfileSidePanel
      environment={props.value.environment}
      freeFieldPermissionProfileId={props.value.freeFieldProfileId}
      trigger={<a>
        {props.value.title}
      </a>}
    />
  </RemovableLabel>;
};